// components/thread-history.js
// ═══════════════════════════════════════════════════════════
// Thread history list. Display only.
// Owns: list rendering, empty state
// Never owns: delete logic, rename persistence (calls props)
// Future props: onShare, onPin, onMoveTo, onToggleSelect
// ═══════════════════════════════════════════════════════════
import ThreadHistoryItem from './thread-history-item';

export default function ThreadHistory({
  threadHistory,
  currentSessionId,
  onLoadThread,
  onDeleteThread,
  onRenameThread,
  onRegenerateTitle,
}) {
  if (!threadHistory?.length) {
    return (
      <div style={{
        color: '#444', fontSize: 12,
        padding: '10px 8px',
        fontFamily: 'Georgia, serif',
      }}>
        No threads yet.
      </div>
    );
  }

  return (
    <>
      {threadHistory.map((t, i) => (
        <ThreadHistoryItem
          key={t.id}
          t={t}
          i={i}
          total={threadHistory.length}
          currentSessionId={currentSessionId}
          onLoad={onLoadThread}
          onDelete={onDeleteThread}
          onRename={onRenameThread}
          onRegenerateTitle={onRegenerateTitle}
        />
      ))}
    </>
  );
}
